<template>
  <div class="mt-4  px-5">
    <v-alert dense text shaped type="info">
      <b>Mitgliederverwaltung</b>
      <div>
        Hier werden alle schuetzenbuch.de-Mitglieder angezeigt, die Eurem Verein
        beitreten möchten oder bereits beigetreten sind.<br /><br />
        Über das <b>„Action"</b>-Menü stehen folgende Möglichkeiten zur
        Verfügung:
        <ul style="margin-top: 8px;">
          <li>
            <b>Mitgliedschaft bestätigen</b> – Erst nach der Bestätigung kann
            das Mitglied eigene schuetzenbuch.de-Einträge anlegen.
          </li>
          <li>
            <b>Aufsicht</b> – Das Mitglied kann sich als Standaufsicht für den
            Verein anmelden.
          </li>
          <li>
            <b>Genehmigen</b> – Das Mitglied erhält die Berechtigung,
            schuetzenbuch.de-Einträge anderer Vereinsmitglieder zu genehmigen.
          </li>
          <li>
            <b>Schießleiter</b> – Das Mitglied erhält Zugriff auf die
            <b>„Heute"</b>-Ansicht in seinem Profil. Dort sieht es, wer aktuell
            als Standaufsicht, Schießleiter oder Schütze angemeldet ist, und
            kann diese Anmeldungen bei Bedarf beenden.
          </li>
        </ul>
      </div>
    </v-alert>
    <v-data-table
      :headers="comp_table_headers"
      :items="comp_ClubMember"
      sort-by="name"
      class="elevation-1"
      ref="ClubMember"
      :search="search"
      :item-class="memberRowClass"
    >
      <template v-slot:top>
        <v-toolbar flat color="green lighten-1"
          ><h2>Mitglieder</h2>
          <v-text-field
            v-model="search"
            class="mx-4"
            append-icon="mdi-magnify"
            label="Suchen"
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
          <new-member-from-club></new-member-from-club>
          <v-btn icon @click="getClubMember">
            <v-icon>mdi-reload</v-icon>
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.isVAdmin="{ item }">
        <v-icon
          v-if="item.isVAdmin"
          class="d-flex justify-center"
          color="success"
        >
          mdi-check
        </v-icon>
        <v-icon v-if="!item.isVAdmin" class="d-flex justify-center" color="red">
          mdi-window-close
        </v-icon>
      </template>

      <template v-slot:item.aufsicht_from="{ item }">
        <span v-if="item.aufsicht_from != null"
          >{{
            new Date(item.aufsicht_from.replace(" ", "T")).toLocaleString([], {
              dateStyle: "short"
            })
          }}
        </span>
      </template>

      <template v-slot:item.can_aufsicht="{ item }">
        <v-icon
          v-if="item.can_aufsicht"
          class="d-flex justify-center"
          color="success"
        >
          mdi-check
        </v-icon>
        <v-icon
          v-if="!item.can_aufsicht"
          class="d-flex justify-center"
          color="red"
        >
          mdi-window-close
        </v-icon>
      </template>

      <template v-slot:item.is_schiessleiter="{ item }">
        <v-icon
          v-if="item.is_schiessleiter"
          class="d-flex justify-center"
          color="success"
        >
          mdi-check
        </v-icon>
        <v-icon
          v-if="!item.is_schiessleiter"
          class="d-flex justify-center"
          color="red"
        >
          mdi-window-close
        </v-icon>
      </template>

      <template v-slot:item.rfid_tag="{ item }" v-if="comp_can_RFID">
        <span v-if="item.rfid_tag" class="d-flex justify-center">
          {{ item.rfid_tag }}</span
        >

        <v-icon v-if="!item.rfid_tag" class="d-flex justify-center" color="red">
          mdi-nfc-variant-off
        </v-icon>
      </template>

      <template v-slot:item.is_Mitglied="{ item }">
        <v-icon
          v-if="item.is_Mitglied != null"
          class="d-flex justify-center"
          color="success"
        >
          mdi-check
        </v-icon>
        <v-icon v-else class="d-flex justify-center" color="red">
          mdi-window-close
        </v-icon>
      </template>
      <template v-slot:item.action_menu="{ item }">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" dark v-bind="attrs" v-on="on">
              <v-icon>mdi-arrow-down</v-icon>
            </v-btn>
          </template>
          <v-list shaped>
            <v-list-item-group color="primary">
              <v-list-item
                @click="setMemberShip(item)"
                v-if="item.is_Mitglied == null"
              >
                <v-list-item-icon>
                  <v-icon class="mr-1" color="success"
                    >fas fa-people-arrows
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title>Ist ein Mitglied</v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="openChangeMemberDialog(item)"
                v-if="item.is_Mitglied !== null"
              >
                <v-list-item-icon>
                  <v-icon class="mr-1" color="blue">fas fa-pen </v-icon>
                </v-list-item-icon>
                <v-list-item-title>Mitglied ändern</v-list-item-title>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item
                @click="setAufsicht(item)"
                v-if="item.is_Mitglied != null"
              >
                <v-icon v-if="item.can_aufsicht === 1" class="mr-2"
                  >mdi-window-close
                </v-icon>
                <v-list-item-title v-if="item.can_aufsicht === 1">
                  Aufsicht entziehen
                </v-list-item-title>

                <v-icon
                  v-if="item.can_aufsicht === 0 || item.can_aufsicht === null"
                  class="mr-2"
                  >fas fa-key
                </v-icon>
                <v-list-item-title
                  v-if="item.can_aufsicht === 0 || item.can_aufsicht === null"
                >
                  Freigabe Aufsicht
                </v-list-item-title>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item
                @click="setVAdmin(item)"
                v-if="item.is_Mitglied != null"
              >
                <v-icon v-if="item.isVAdmin === 1" class="mr-2"
                  >mdi-window-close
                </v-icon>
                <v-list-item-title v-if="item.isVAdmin === 1"
                  >darf nicht mehr Genehmigen
                </v-list-item-title>

                <v-icon v-if="item.isVAdmin === 0" class="mr-2"
                  >fas fa-plus-circle
                </v-icon>
                <v-list-item-title v-if="item.isVAdmin === 0"
                  >darf Genehmigen
                </v-list-item-title>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item
                @click="setSchiessleiter(item)"
                v-if="item.is_Mitglied != null"
              >
                <v-icon v-if="item.is_schiessleiter === 1" class="mr-2"
                  >mdi-window-close
                </v-icon>
                <v-list-item-title v-if="item.is_schiessleiter === 1">
                  Schießleiter entziehen
                </v-list-item-title>

                <v-icon v-if="item.is_schiessleiter === 0" class="mr-2"
                  >mdi-pistol
                </v-icon>
                <v-list-item-title v-if="item.is_schiessleiter === 0">
                  Schießleiter vergeben
                </v-list-item-title>
              </v-list-item>
              <v-divider v-if="comp_can_RFID"></v-divider>
              <v-list-item @click="openDialogRFID(item)" v-if="comp_can_RFID">
                <v-icon class="mr-2">fas fa-credit-card </v-icon>
                <v-list-item-title>RFID Chip zuweisen</v-list-item-title>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item
                @click="del_Member_Dialog(item)"
                v-if="item.is_Mitglied != null"
              >
                <v-icon class="mr-2" color="error">fas fa-trash-alt </v-icon>
                <v-list-item-title>Mitglied löschen</v-list-item-title>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">
          Reset
        </v-btn>
      </template>
    </v-data-table>

    <!--    Dialog Change RFID -->
    <v-dialog
      v-model="dialog_rfid"
      transition="dialog-top-transition"
      width="600"
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          RFID Chip dem Mitglied zuweisen
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialogRFID">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="form" v-on:submit.prevent>
            <v-container>
              <v-row>
                <v-col cols="3">
                  <v-subheader class="mySubheader"
                    >Nummer des RFID Chips</v-subheader
                  >
                </v-col>
                <v-col cols="8">
                  <span id="Hinweis_span"
                    >Im Idealfall vom Tastatur RFID Leser einfügen</span
                  >
                  <v-text-field
                    v-model="RFIDToken"
                    :rules="[rules.counter]"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="card-actions">
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="closeDialogRFID">
            Abbrechen
          </v-btn>
          <v-btn color="green darken-1" text @click="setRFID()">
            Speichern
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--    Dialog Update Mitglied -->
    <member-update-dialog
      @closeDialogMemberChange="closeDialogMemberChange"
      :showDialogMemberChange.sync="dialog_member_update"
      :member="EditMember"
    >
    </member-update-dialog>

    <v-dialog v-model="dialogDelete" max-width="550px">
      <v-card>
        <v-card-title class="text-h5"
          >Willst du dieses Mitglied wirklich löschen?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="
              dialogDelete = false;
              prepare_delete_member = {};
            "
            >Abbrechen</v-btn
          >
          <v-btn
            color="blue darken-1"
            text
            @click="setMemberShip(prepare_delete_member)"
            >OK</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import newMemberFromClub from "@/views/component/newMemberFromClub.vue";
import MemberUpdateDialog from "@/views/component/MemberUpdateDialog.vue";

export default {
  name: "members",
  components: { newMemberFromClub, MemberUpdateDialog },
  data: () => ({
    dialog: false,
    dialogDelete: false,
    prepare_delete_member: {},
    dialog_rfid: false,
    errorMessages: "",
    dialog_member_update: false,
    show_password: false,
    loading: false,
    RFIDToken: "",
    RFID_UserID: "",
    EditMember: {},
    search: "",
    headers: [
      {
        align: "Name",
        sortable: false
      },
      { text: "Name", value: "name" },
      { text: "Vorname", value: "vorname" },
      { text: "Mitgliedsnummer", value: "Mitgliedsnummer" },
      { text: "Mitglied im Verein", value: "is_Mitglied" },
      { text: "Aufsicht im Verein seit", value: "aufsicht_from" },
      { text: "Freigabe zur Aufsicht", value: "can_aufsicht" },
      { text: "Genehmigen", value: "isVAdmin" },
      { text: "Schießleiter", value: "is_schiessleiter" },
      { text: "Action", value: "action_menu", sortable: false }
    ],
    rules: {
      required: value => !!value || "Pflichtfeld.",
      counter: value => value.length <= 200 || "Max 200 Zeichen",
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Ungültige E-Mail.";
      }
    }
  }),

  computed: {
    comp_ClubMember() {
      return this.$store.state.ClubApp.ClubMember;
    },
    comp_can_RFID() {
      return this.$store.getters["ClubAuth/can_RFID"];
    },
    comp_table_headers() {
      let header = this.headers;
      if (this.comp_can_RFID) {
        header.splice(header.length - 1, 0, {
          text: "RFID Chip",
          value: "rfid_tag"
        });
      }
      return header;
    }
  },
  mounted() {
    this.getClubMember();
  },
  methods: {
    getClubMember() {
      this.$store.dispatch("ClubApp/getClubMember");
    },
    setVAdmin(item) {
      this.loading = true;

      var Data = {
        UserID: item.UserID,
        VadminID: item.id,
        VadminBol: item.isVAdmin
      };
      this.$store
        .dispatch("ClubApp/setClubMemberAdmin", Data)
        .then((this.loading = false));
    },

    setAufsicht(item) {
      this.loading = true;

      var Data = {
        UserID: item.UserID,
        VadminID: item.id,
        can_aufsicht: item.can_aufsicht
      };
      this.$store
        .dispatch("ClubApp/setClubMemberAufsicht", Data)
        .then((this.loading = false));
    },

    setMemberShip(item) {
      this.loading = true;

      var Data = {
        club_user_id: item.id,
        User_id: item.UserID,
        is_Member: item.is_Mitglied != null ? 1 : 0
      };

      this.$store
        .dispatch("ClubApp/setClubMemberMemberShip", Data)
        .then((this.loading = false));

      this.dialogDelete = false;
    },
    openDialogRFID(item) {
      this.dialog_rfid = true;
      this.RFID_UserID = item.UserID;
    },
    async setRFID() {
      const Data = {
        UserID: this.RFID_UserID,
        RFIDToken: this.RFIDToken
      };

      if (this.$refs.form.validate()) {
        await this.$store
          .dispatch("ClubApp/setMemberRFIDToken", Data)
          .then(
            (this.dialog_rfid = false),
            (this.RFID_UserID = ""),
            (this.RFIDToken = "")
          );
      }
    },

    openChangeMemberDialog(item) {
      this.EditMember = Object.assign({}, item);
      this.dialog_member_update = true;
    },

    closeDialogRFID() {
      this.dialog_rfid = false;
      this.RFID_UserID = "";
      this.RFIDToken = "";
    },

    del_Member_Dialog(item) {
      this.dialogDelete = true;
      this.prepare_delete_member = Object.assign({}, item);
    },

    setSchiessleiter(item) {
      this.loading = true;
      const Data = {
        club_user_id: item.id,
        is_schiessleiter: item.is_schiessleiter
      };
      this.$store
        .dispatch("ClubApp/setClubMemberSchiessleiter", Data)
        .then((this.loading = false));
    },

    memberRowClass(item) {
      return item.is_Mitglied == null ? "member-pending" : "";
    },

    closeDialogMemberChange() {
      this.dialog_member_update = false;
      this.EditMember = Object.assign({}, {});
    },
    initialize() {
      this.getClubMember();
    }
  }
};
</script>

<style scoped>
.mySubheader {
  font-weight: bold;
}

#Hinweis_span {
  font-weight: bold;
}
</style>

<style>
.member-pending {
  background-color: #fff8e1 !important;
}
</style>
